import { useCallback, useMemo, useState } from 'react';
import { AFFILIATION_FILTER_ALL } from '../utils/affiliationHelpers';
import {
  buildCompanyListStats,
  CITY_FILTER_ALL,
  DEFAULT_COMPANY_LIST_FILTERS,
  filterCompanies,
  hasCompanyListFilters
} from '../components/companies/companyListUtils';

export function useCompanyListFilters(companies, { affiliations = [], cities = [] } = {}) {
  const [search, setSearch] = useState(DEFAULT_COMPANY_LIST_FILTERS.search);
  const [statusFilter, setStatusFilter] = useState(DEFAULT_COMPANY_LIST_FILTERS.statusFilter);
  const [affiliationFilter, setAffiliationFilter] = useState(
    DEFAULT_COMPANY_LIST_FILTERS.affiliationFilter
  );
  const [cityFilter, setCityFilter] = useState(DEFAULT_COMPANY_LIST_FILTERS.cityFilter);

  const filters = useMemo(
    () => ({ search, statusFilter, affiliationFilter, cityFilter }),
    [search, statusFilter, affiliationFilter, cityFilter]
  );

  const filteredCompanies = useMemo(
    () => filterCompanies(companies, { ...filters, affiliations, cities }),
    [companies, filters, affiliations, cities]
  );

  const stats = useMemo(
    () => buildCompanyListStats(filteredCompanies, companies.length, filters),
    [filteredCompanies, companies.length, filters]
  );

  const hasActiveFilters = useMemo(() => hasCompanyListFilters(filters), [filters]);

  const clearFilters = useCallback(() => {
    setSearch(DEFAULT_COMPANY_LIST_FILTERS.search);
    setStatusFilter(DEFAULT_COMPANY_LIST_FILTERS.statusFilter);
    setAffiliationFilter(DEFAULT_COMPANY_LIST_FILTERS.affiliationFilter);
    setCityFilter(DEFAULT_COMPANY_LIST_FILTERS.cityFilter);
  }, []);

  return {
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    affiliationFilter,
    setAffiliationFilter,
    cityFilter,
    setCityFilter,
    filteredCompanies,
    stats,
    hasActiveFilters,
    clearFilters,
    filters
  };
}

export default useCompanyListFilters;
